import { apiService } from "./apiService";
import { endpoints } from "../config/endpoints";

export default {
  getWebsitesData() {
    return apiService.get(endpoints.websites);
  },

  getLocations(data, websiteId) {
    return apiService(data).get(`${endpoints.websites}${websiteId}/keywords/`);
  },

  getKeywordsByLocation(websiteId, locationId) {
    return apiService.get(
      `${endpoints.websites}${websiteId}/keywords/?search_location=${locationId}`
    );
  },

  getKeywordData({ websiteId, locationId, keywordId }, { from, to }) {
    return apiService.get(
      `organic-search-results/?website=${websiteId}&search_location=${locationId}&keyword=${keywordId}&searched_at__gte=${from}&searched_at__lt=${to}`
    );
  },

  postWebsites(websites) {
    return apiService.post(endpoints.websites, websites);
  },

  deleteWebsite(websiteId) {
    return apiService.delete(`${endpoints.websites}${websiteId}/`);
  },

  getLastQualityAudit(id) {
    return apiService.get(`${endpoints.websites}${id}/quality-audits/last/`);
  },

  getHistoricalAudits(id, { from, to }) {
    return apiService.get(
      `${endpoints.websites}${id}/quality-audits/?created_at__gte=${from}&created_at__lte=${to}`
    );
  },

  getCompetitionOrganicSearchData(
    { competitionWebsiteId, websiteId, locationId, keywordId },
    { from, to }
  ) {
    return apiService.get(
      `organic-search-competition/?website_competition=${competitionWebsiteId}&website=${websiteId}&search_location=${locationId}&keyword=${keywordId}&searched_at__gte=${from}&searched_at__lt=${to}`
    );
  }
};
